import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Container, Typography, Divider } from '@mui/material';
import useResponsive from '../hooks/useResponsive';
import { Logo } from '../components/logo';
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 580,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows?.card || '0px 4px 20px rgba(0, 0, 0, 0.1)',
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Login | InnoWave API Hub </title>
      </Helmet>

      <StyledRoot>
        <Logo
          alt="Innowave"
          title="Innowave Logo"
          loading="eager"
          sx={{
            position: {
              xs: 'static', // scrolls with content on mobile
              sm: 'fixed',  // fixed only for larger screens
            },
            top: { xs: 'auto', sm: 0, md: 0 },
            left: {
              xs: 'auto', // no need to manually center when static
              sm: 20,
              md: 20,
            },
            transform: {
              xs: 'none',
              sm: 'none',
            },
            display: 'block',
            margin: { xs: '16px auto', sm: 0 }, // center with margin on mobile
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography sx={{ px: 5, mt: 10, mb: 5, fontSize: '2.3rem', fontWeight: 'bold', textAlign: 'center' }}>
              Hi, Welcome Back
            </Typography>
            <img
              src="/assets/illustrations/rb_3180.jpg"
              alt="Login"
              width="100%"
              height="auto"
              loading="lazy"
              title="Login"
            />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Typography sx={{ fontSize: '2rem', fontWeight: 'bold' }} gutterBottom>
              Sign in to InnoWave API Hub
            </Typography>

            <Typography variant="body2" sx={{ mb: 3 }}>
              Don’t have an account? <Link to="/signup" style={{ color: '#66023c' }}>Get started</Link>
            </Typography>
            {/* <Stack direction="row" spacing={2}>
              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />
              </Button>

              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />
              </Button>

              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />
              </Button>
            </Stack> */}

            <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                OR
              </Typography>
            </Divider>
            <br />

            <LoginForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
